import { AssetStateTypeDto } from './models';

export class AssetStateTypeDtoEmpty implements AssetStateTypeDto{
  name = '';
}